import { FC } from 'react';
import { useSelector } from 'react-redux';
import {
  FrequencyModeSelect,
  createMediumSelectOptions,
} from 'modules/frequencyManagement/components/frequencyModeSelect/FrequencyModeSelect';
import { useWatch } from 'react-hook-form';
import { FrequencyMode, SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { selectIsFrequencyManageOptimizeFlagOn } from 'core/userContext';
import { useEditStateContext } from 'modules/frequencyManagement/contexts/EditStateContext';
import { useOptimizeModeTotal } from 'modules/frequencyManagement/hooks/useOptimizeModeTotal';
import { MODE } from 'modules/frequencyManagement/contexts/FormProvider';
import { EngagementMetrics } from 'modules/frequencyManagement/components/engagementMetrics/EngagementMetrics';
import { Body2Light } from '../Content.styles';
import {
  Wrapper,
  HeaderRow,
  HeadingWithMetrics,
  Right,
  Description,
} from './MessageMediumCard.styles';
import { CardBody } from './CardBody';
import {
  MESSAGE_MEDIUM_CARD_TEST_ID,
  createMessageMediumHeaderDescription,
} from './MessageMediumCard.constants';

export interface MessageMediumContainerProps {
  messageMedium: SupportedMediums;
}
export const MessageMediumCard: FC<MessageMediumContainerProps> = ({ messageMedium }) => {
  const { isEditingMedium, setIsEditingMedium } = useEditStateContext();
  const isOptimizeEnabled = useSelector(selectIsFrequencyManageOptimizeFlagOn);
  const { isAtOptimizeLimit } = useOptimizeModeTotal(messageMedium);
  const mode = useWatch({ name: MODE });
  return (
    <Wrapper data-test={`${messageMedium}-${MESSAGE_MEDIUM_CARD_TEST_ID}`}>
      <HeaderRow>
        <HeadingWithMetrics>
          {messageMedium} Frequency{' '}
          <EngagementMetrics isOptimizeEnabled={isOptimizeEnabled} messageMedium={messageMedium} />
        </HeadingWithMetrics>
        <Description>
          <Body2Light>{createMessageMediumHeaderDescription(messageMedium)}</Body2Light>
        </Description>
        <Right>
          <FrequencyModeSelect
            options={createMediumSelectOptions(
              messageMedium,
              isOptimizeEnabled,
              isAtOptimizeLimit && mode !== FrequencyMode.Optimize,
            )}
            isEditing={isEditingMedium}
            setIsEditing={setIsEditingMedium}
          />
        </Right>
      </HeaderRow>
      <CardBody
        messageMedium={messageMedium}
        isEditingMedium={isEditingMedium}
        isOptimizeEnabled={isOptimizeEnabled}
      />
    </Wrapper>
  );
};
